import React, { useEffect, useState, useRef } from 'react';
import { compose } from 'ramda';
import styleFile from './header.js';
import { withThemeJSS } from '@synergycms_core/components/providers/themeProvider';

const LoginModule = compose(withThemeJSS({ styleFile, displayName: 'Header' }))((props) => {
  const { classes } = props.theme.styles;
  const [, setIsOpen] = useState(true);
  const modalRef = useRef(null);

  useEffect(() => {
    const loginRoot = document.getElementById('cms-login-dispo');
    if (loginRoot && !loginRoot.hasChildNodes() && window.frontLoader?.['cms-login']?.render) {
      window.frontLoader['cms-login'].render('cms-login-dispo');
    }
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        modalRef.current &&
        !modalRef.current.contains(event.target) &&
        !event.target.closest(`.${classes.langSelectorBtn}`) // Evita que el LangSelector evite el cierre
      ) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [classes.langSelectorBtn]);

  return <div ref={modalRef} className={classes.loginContainer} id="cms-login-dispo" />;
});


export default LoginModule;